import personalMessageResx from 'Resx/PersonalMessage/PersonalMessage.resx';
import ImageDTO from 'Js/api/v1/DTO/ImageDTO';
import DiscountsDTO from 'Js/api/v1/DTO/discounts/DiscountsDTO';

export default class UserDTO {
    constructor({
        Id,
        ProfileLink,
        Link,
        CompanyName,
        FirstName,
        MiddleName,
        LastName,
        Email,
        PhoneNumber,
        Description,
        Payment,
        Rating,
        Logo,
        IconLink,
        groupId,
        SellerSiteId,
        iSellerCurrency,
        IsAdmin,
        IsSeller,
        IsProfessional,
        IsActivePro,
        IsVip,
        MailingLang,
        IsAvtoServiceAccount,
        Discounts,
        IsActiveMiniProfessionalAccount,
        HasProSto,
        IsActivatedTelegramChat,
        IsPenaltyRate,
        IsDropshipper,
        Login,
        TaxNumber,
        IsPhoneConfirmed
    }) {
        this.id = parseInt(Id, 10) || 0;
        this.profileLink = ProfileLink || Link;
        this.companyName = CompanyName;
        this.firstName = FirstName;
        this.middleName = MiddleName;
        this.lastName = LastName;
        this.email = Email;
        this.phoneNumber = PhoneNumber;
        this.description = Description;
        this.payment = Payment;
        this.rating = Rating;
        this.avatar = IconLink;
        this.sellerSiteId = SellerSiteId;
        this.isAdmin = IsAdmin || null;
        this.isSeller = IsSeller === 'true' || IsSeller === true;
        this.isProfessional =
            IsProfessional === 'true' || IsProfessional === true;
        this.isActivePro = IsActivePro;
        // TODO: стандартизировать
        this.logo =
            typeof Logo == 'string'
                ? ImageDTO.parseFromString(Logo)
                : Logo && new ImageDTO(Logo);
        this.groupId = groupId ? Number(groupId) : null;
        this.iSellerCurrency = iSellerCurrency || null;
        this.isVip = IsVip;
        this.mailingLang = MailingLang;
        this.isAvtoServiceAccount = IsAvtoServiceAccount;
        this.discounts = Discounts ? new DiscountsDTO(Discounts) : null;
        this.isActiveMiniProfessionalAccount = IsActiveMiniProfessionalAccount;
        this.hasProSto = HasProSto;
        this.hasPenaltyRate = IsPenaltyRate;
        this.isActivatedTelegramChat = IsActivatedTelegramChat;
        this.isDropshipper = IsDropshipper;
        this.isPhoneConfirmed = IsPhoneConfirmed;
        this.login = Login;
        this.taxNumber = TaxNumber;
    }

    get isGuest() {
        return this.id == 75;
    }

    get name() {
        if (this.isAdmin) {
            return personalMessageResx.PMAdminDTO;
        }
        if (this.companyName) {
            return this.companyName;
        }
        const name = [this.lastName].join(' ').trim();
        return (
            name ||
            personalMessageResx.PMUserDTOSellerWithID.replace('{0}', this.id)
        );
    }

    get fullName() {
        if (this.isAdmin) {
            return personalMessageResx.PMAdminDTO;
        }
        if (this.companyName) {
            return this.companyName;
        }
        const name = [this.firstName, this.middleName, this.lastName]
            .join(' ')
            .trim();
        return (
            name ||
            personalMessageResx.PMUserDTOSellerWithID.replace('{0}', this.id)
        );
    }

    get link() {
        return this.profileLink ? `/seller/${this.profileLink}/` : null;
    }

    toJSON() {
        return {
            Id: this.id,
            ProfileLink: this.profileLink,
            CompanyName: this.companyName,
            FirstName: this.firstName,
            MiddleName: this.middleName,
            LastName: this.lastName,
            Description: this.description,
            Payment: this.payment
        };
    }

    toString() {
        return this.fullName;
    }

    static parse(args) {
        return args ? new UserDTO(args) : null;
    }
}
